import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectStartingRow } from './selectors';

export interface Props {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

export default function StartingRowTableCell(props: Props): React.ReactElement {
    const { pageIndex, entitySummaryIndex } = props;
    const startingRow = useSelector((state: AppState) =>
        makeSelectStartingRow()(state, { pageIndex, entitySummaryIndex })
    );

    return <TableCell>{startingRow}</TableCell>;
}
